import {StateCreator} from 'zustand'
import {TPermissionResponse} from '../types/permission.type'

type State = {
  permissions: {[projectId: string]: TPermissionResponse | undefined}
  clientPermissions: {[clientId: string]: TPermissionResponse | undefined}
}

type Action = {
  setPermissions: (projectId: string, permissions: TPermissionResponse) => void
  clearPermissions: (projectId: string) => void
  clearAllPermissions: () => void
  setClientPermissions: (
    clientId: string,
    permissions: TPermissionResponse,
  ) => void
  clearClientPermissions: (clientId: string) => void
  clearAllClientPermissions: () => void
}

export type PermissionSlice = State & Action

const createPermissionSlice: StateCreator<PermissionSlice> = set => ({
  permissions: {},
  clientPermissions: {},

  setPermissions: (projectId, permissions) =>
    set(state => ({
      permissions: {...state.permissions, [projectId]: permissions},
    })),

  clearPermissions: projectId =>
    set(state => {
      const newPermissions = {...state.permissions}
      delete newPermissions[projectId]
      return {permissions: newPermissions}
    }),

  clearAllPermissions: () => set({permissions: {}}),

  setClientPermissions: (clientId, permissions) =>
    set(state => ({
      clientPermissions: {...state.clientPermissions, [clientId]: permissions},
    })),

  clearClientPermissions: clientId =>
    set(state => {
      const newClientPermissions = {...state.clientPermissions}
      delete newClientPermissions[clientId]
      return {clientPermissions: newClientPermissions}
    }),

  clearAllClientPermissions: () => set({clientPermissions: {}}),
})

export default createPermissionSlice
